export const apiUrl = process.env.NEXT_PUBLIC_DIRECTUS_URL || "http://localhost:8055";
export const directusToken = process.env.NEXT_TOKEN || "XTEOwoxmCcj3zN4O-cP5eFgVBUIgtZmm";
